import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from './services/user.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'oficina';
  desarrollo = environment.production

  constructor(private router: Router, private _userService: UserService, private messageService: MessageService){
    this.getConfig();
  }

  @HostListener('window:beforeunload')
  onUnload(): void {
    if(this.desarrollo){
      sessionStorage.clear();
      this.router.navigate(['/login'])
    }
  }

  getConfig() {
    this._userService.httpGet('parametrosConfig').subscribe(
      (response: any) => {

        //localStorage.setItem('config', JSON.stringify(response.details))
        this._userService.SetsessionStorage('config', JSON.stringify(response.details))

      },
      error => {
        console.log(error as any);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
      }
    )
  }
}
